import React from 'react'
import { css } from '@emotion/core'
import { ReservationNote } from '@/models/dashboard/dashboard-reservation'
import { isFrontMemo, isCleaningMemo, isMealMemo } from '@/models/reservation/reservation-note'

type ReservationMemoCellProps = {
  memoList: ReservationNote[]
}

export const ReservationMemoCell: React.FC<ReservationMemoCellProps> = ({ memoList }) => {
  return (
    <div css={memoCellStyle}>
      {/* フロント用メモ */}
      <MemoRow
        iconSrc={require(`@/static/images/reservation-note/icon_front.svg`)}
        memo={memoList.find(({ category }) => isFrontMemo(category))?.memo || '-'}
      />
      {/* クリーニング用メモ */}
      <MemoRow
        iconSrc={require(`@/static/images/reservation-note/icon_cleaning.svg`)}
        memo={memoList.find(({ category }) => isCleaningMemo(category))?.memo || '-'}
      />
      {/* 食事用メモ */}
      <MemoRow
        iconSrc={require(`@/static/images/reservation-note/icon_meal.svg`)}
        memo={memoList.find(({ category }) => isMealMemo(category))?.memo || '-'}
      />
    </div>
  )
}

type MemoRowProps = {
  iconSrc: string
  memo: string
}

/**
 * メモ1行を表示するコンポーネント
 * アイコンとメモテキストを組み合わせて表示
 * @param iconSrc アイコンのパス
 * @param memo メモテキスト
 */
const MemoRow: React.FC<MemoRowProps> = ({ iconSrc, memo }) => (
  <div>
    <img src={iconSrc} alt="" />
    <p css={wrapTextStyle}>{memo}</p>
  </div>
)

const memoCellStyle = css({
  div: {
    display: 'flex',
    alignItems: 'center',
    '& + div': { marginTop: 12 },
    gap: 14,
  },
})

const wrapTextStyle = css({
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
})
